export default{
    lista:{
        method:'get',
        url:'aviso/lista'
    },
    cadastra:{
        method:'post',
        url:'aviso/cadastro'
    },
    delete:{
        method:'delete',
        url:'aviso/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'aviso/editar{/id}'
    },
    update:{
        method:'post',
        url:'aviso/update'
    },
    busca:{
        method:'get',
        url:'depedente/busca{/id}'
    },
    buscaempresa:{
        method:'get',
        url:'empresa/pesquisa'
    },
}